import classnames from 'classnames';
import snakeCase from 'lodash/snakeCase';
import React from 'react';

interface Props {
  id: string;
  options: string[];
  selected: string[];
  multiSelect: boolean;
  radioMode: boolean;
  disabled: boolean;
  onOptionClick: Function;
}

class BasicButtonGroup extends React.Component<Props> {
  static defaultProps = {
    multiSelect: false,
    radioMode: false,
    disabled: false,
  };

  handleOptionClick = (option: string): void => {
    const { onOptionClick, selected, multiSelect, radioMode } = this.props;
    const s = new Set(selected);

    if (multiSelect) {
      if (s.has(option)) {
        s.delete(option);
      } else {
        s.add(option);
      }

      onOptionClick([...s]);
      return;
    }

    // Is single select
    if (radioMode) {
      if (!s.has(option)) {
        onOptionClick([option]);
      }
      return;
    }

    if (s.has(option)) {
      s.delete(option);
    } else {
      s.clear();
      s.add(option);
    }

    onOptionClick([...s]);
  };

  render(): React.ReactNode {
    const { id, options, selected, disabled } = this.props;

    return (
      <div
        id={id}
        className={classnames('row oh bgd-white b-solid b-width-1 normal ', {
          'b-light-grey-1': disabled,
          'b-gray-7': !disabled,
        })}
        style={{
          borderRadius: '.25rem',
        }}
      >
        {options.map((option: string, idx: number): React.ReactNode => {
          const isSelected = selected.indexOf(option) > -1;

          return (
            <div
              id={`${id}-option-${snakeCase(option)}`}
              key={option}
              data-testid={`${id}-option-${idx}`}
              className={classnames('px2 hs2 flex-center capitalize shrink-0', {
                'bgd-gray-7 color-white': isSelected,
                'bgd-white': !isSelected,
                'cursor-not-allowed': disabled,
                'cursor-pointer': !disabled,
                'opacity-50': !isSelected && disabled,
                'bl-light-grey-1 bl-solid bl-width-2': idx > 0 && disabled,
                'bl-gray-7 bl-solid bl-width-2': idx > 0 && !disabled,
              })}
              style={{ minWidth: '6rem' }}
              onClick={(): void => {
                if (!disabled) {
                  this.handleOptionClick(option);
                }
              }}
            >
              {option}
            </div>
          );
        })}
      </div>
    );
  }
}

export default BasicButtonGroup;
